module.exports = __webpack_public_path__ + "static/media/veneto-village-30.6e96ffdd.jpg";